<template>
    <transition-group type="div" class="cluster-member-community-list" name="fade">
        <div v-for="logo in visibleLogos" :key="logo.id" class="cluster-member-item">
            <a :href="logo.url" class="cluster-member-icon">
                <img :src="logo.image" :alt="logo.title">
            </a>
        </div>
    </transition-group>
</template>

<style lang="scss">
@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.fade-enter-active, .fade-leave-active {
    animation: fade-in 600ms forwards ease-in-out;
}


.fade-enter, .fade-leave-to {
    display: none;
}
</style>

<script>
export default {
    props: {
        entries: {
            type: Array,
            required: true
        },
        timeout: {
            type: Number,
            required: false,
            default: 1000
        },
        limit: {
            type: Number,
            required: false,
            default: 20,
        }
    },
    data() {
        return {
            visibleLogos: []
        }
    },
    created() {
        if ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
            this.limit = 15;
        }

        this.visibleLogos = this.entries.slice(0, this.limit);

        if (this.entries.length > this.limit) {
            setInterval(() => this.swapRandomLogo(), this.timeout);
        }
    },
    methods: {
        swapRandomLogo() {
            let replacing = this.visibleLogos[Math.floor(Math.random() * this.visibleLogos.length)];
            let replacer = this.entries[Math.floor(Math.random() * this.entries.length)];

            // Retry until we don't get the same logo or one we already have
            if (replacing.id === replacer.id || this.visibleLogos.find((l) => l.id === replacer.id)) {
                return this.swapRandomLogo();
            }

            let replacingIndex = this.visibleLogos.findIndex((l) => l.id === replacing.id);

            this.visibleLogos.splice(replacingIndex, 1, replacer);
        }
    }
}
</script>
